import apiClient from './apiClient';

export interface EventDetails {
  Events_ID: string;
  title: string;
  sub_title?: string;
  event_date: string;
  location_name?: string;
  street?: string;
  house_number?: string;
  postal_code?: string;
  city?: string;
  country?: string;
  status?: number;
}

export interface EventRegistrationResponse {
  message: string;
  registered?: boolean;
  needs_verification?: boolean;
}

/**
 * Get details of a specific event
 * This can be accessed without authentication
 */
export async function getEventDetails(eventId: string): Promise<EventDetails> {
  try {
    const response = await apiClient.get<EventDetails>(`/api/v2/web/events/${eventId}/details`);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching event details:', error);
    // Enhance the error message with status code information
    if (error?.response?.status === 404) {
      throw new Error('Event not found (404)');
    }
    throw error;
  }
}

/**
 * Check if a user is registered for an event
 */
export async function checkUserRegistration(
  email: string, 
  verificationCode: string, 
  eventId: string
): Promise<EventRegistrationResponse> {
  try {
    const response = await apiClient.post<EventRegistrationResponse>('/api/v2/web/check_user', {
      email,
      verification_code: verificationCode,
      event_id: eventId
    });
    return response.data;
  } catch (error) {
    console.error('Error checking user registration:', error);
    throw error;
  }
}

/**
 * Register a user for an event
 */
export async function registerForEvent(
  email: string,
  verificationCode: string,
  firstname: string,
  lastname: string,
  eventId: string
): Promise<EventRegistrationResponse> {
  try {
    const response = await apiClient.post<EventRegistrationResponse>('/api/v2/web/register', {
      email,
      verification_code: verificationCode,
      firstname,
      lastname,
      event_id: eventId
    });
    return response.data;
  } catch (error) {
    console.error('Error registering for event:', error);
    throw error;
  }
}

/**
 * Verify and register a user for an event
 */
export async function verifyAndRegisterForEvent(
  email: string,
  verificationCode: string,
  firstname: string,
  lastname: string,
  eventId: string
): Promise<EventRegistrationResponse> {
  try {
    const response = await apiClient.post<EventRegistrationResponse>('/api/v2/web/verify_and_register', {
      email,
      verification_code: verificationCode,
      firstname,
      lastname,
      event_id: eventId
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying and registering for event:', error);
    throw error;
  }
}
